import { render, staticRenderFns } from "./operatingRecord.vue?vue&type=template&id=dff8f1ce&scoped=true"
import script from "./operatingRecord.vue?vue&type=script&lang=js"
export * from "./operatingRecord.vue?vue&type=script&lang=js"
import style0 from "./operatingRecord.vue?vue&type=style&index=0&id=dff8f1ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff8f1ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dff8f1ce')) {
      api.createRecord('dff8f1ce', component.options)
    } else {
      api.reload('dff8f1ce', component.options)
    }
    module.hot.accept("./operatingRecord.vue?vue&type=template&id=dff8f1ce&scoped=true", function () {
      api.rerender('dff8f1ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/policy/customerManage/operatingRecord.vue"
export default component.exports